import axios from '@/libs/axios'

const API_BASE_URL = '/edificios'

export default {
  // Obtener todos los edificios
  async getAll() {
    try {
      const response = await axios.get(API_BASE_URL)
      return response.data
    } catch (error) {
      console.error('Error fetching buildings:', error)
      throw error
    }
  },

  // Obtener edificios activos (el endpoint principal ya filtra por estado activo)
  async getActive() {
    try {
      const response = await axios.get(API_BASE_URL)
      return response.data
    } catch (error) {
      console.error('Error fetching active buildings:', error)
      throw error
    }
  },

  // Obtener un edificio por ID
  async getById(id) {
    try {
      const response = await axios.get(`${API_BASE_URL}/${id}`)
      return response.data
    } catch (error) {
      console.error('Error fetching building:', error)
      throw error
    }
  },

  // Crear un nuevo edificio
  async create(buildingData) {
    try {
      const response = await axios.post(API_BASE_URL, buildingData)
      return response.data
    } catch (error) {
      console.error('Error creating building:', error)
      throw error
    }
  },

  // Actualizar un edificio
  async update(id, buildingData) {
    try {
      const response = await axios.put(`${API_BASE_URL}/${id}`, buildingData)
      return response.data
    } catch (error) {
      console.error('Error updating building:', error)
      throw error
    }
  },

  // Eliminar un edificio
  async delete(id) {
    try {
      const response = await axios.delete(`${API_BASE_URL}/${id}`)
      return response.data
    } catch (error) {
      console.error('Error deleting building:', error)
      throw error
    }
  }
}